import { render } from "./Document.vue?vue&type=template&id=18f0fc31"
import script from "./Document.vue?vue&type=script&lang=js"
export * from "./Document.vue?vue&type=script&lang=js"
script.render = render

export default script